// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__P7iLf","btnStyle":"style_btnStyle__NJX_2"};